import Icon from "@/icon";
import { useAppTheme } from "@/theme";
import {
  Box,
  CardContent,
  Paper,
  PaperProps,
  Typography,
  TypographyProps,
  styled,
} from "@mui/material";
import Color from "color";
import { useTranslation } from "react-i18next";

const Put = () => {
  const { t } = useTranslation();
  const theme = useAppTheme();

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"center"}
      gap={4}
    >
      <Typography
        variant={"h4"}
        textAlign={"center"}
        fontWeight={theme.typography.fontWeightBold}
      >
        {t("learn.title")}
      </Typography>
      <Box display={"flex"} gap={2} flexDirection={{ xs: "column", md: "row" }}>
        <StyledPaper theme={theme}>
          <StyledCardContent>
            <Icon
              icon={"activity"}
              size={32}
              color={theme.palette.surface.main}
            />
            <Typography
              variant={"h6"}
              fontWeight={theme.typography.fontWeightBold}
            >
              {t("learn.history-timeline.title")}
            </Typography>
            <StyledTypography>
              {t("learn.history-timeline.description")}
            </StyledTypography>
          </StyledCardContent>
        </StyledPaper>
        <StyledPaper theme={theme}>
          <StyledCardContent>
            <Icon icon={"block"} size={32} color={theme.palette.surface.main} />
            <Typography
              variant={"h6"}
              fontWeight={theme.typography.fontWeightBold}
            >
              {t("learn.block-websites.title")}
            </Typography>
            <StyledTypography>
              {t("learn.block-websites.description")}
            </StyledTypography>
          </StyledCardContent>
        </StyledPaper>
        <StyledPaper theme={theme}>
          <StyledCardContent>
            <Icon
              icon={"notification"}
              size={32}
              color={theme.palette.surface.main}
            />
            <Typography
              variant={"h6"}
              color={theme.palette.surface.main}
              fontWeight={theme.typography.fontWeightBold}
            >
              {t("learn.browser-notifications.title")}
            </Typography>
            <StyledTypography component={"p"}>
              {t("learn.notifications.description")}
            </StyledTypography>
          </StyledCardContent>
        </StyledPaper>
      </Box>
    </Box>
  );
};

const StyledPaper = styled((props: PaperProps) => (
  <Paper {...props} elevation={0} />
))(({ theme }) => ({
  flex: 1,
  background: `linear-gradient(to top, #000, ${theme.palette.primary.main})`,
  color: theme.palette.surface.main,
  borderRadius: theme.shape.borderRadius * 4,
}));

const StyledTypography = styled((props: TypographyProps) => (
  <Typography {...props} variant={"body1"} mt={1} />
))(({ theme }) => ({
  color: Color(theme.palette.surface.main).alpha(0.38).toString(),
}));

const StyledCardContent = styled(CardContent)({
  textAlign: "center",
  gap: 4,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

export default Put;
